export default __webpack_public_path__ + "static/media/fastfood-24px.73b3ccfc.svg";